export default "https://cdn-static.gokick.com/assets/31e0b9f53043906ee01608417204ccf2abfa2ab1/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";